import { useEffect, useState, useRef} from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Box,Text,Button, Table,Thead,Tbody,Tr,
  Th,Td,Select } from '@chakra-ui/react';
import { selectedMenu } from "../../../redux/actions/actions";
import { loadAttendanceReport,loadAllAttendance } from '../../../redux/api_calls/apiCalls'

export default function CalendarSchedule() {
    const { attendanceAllData } = useSelector(state => state.attendanceAllState)
    const { attendanceReportsData } = useSelector(state => state.attendanceReportsState)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()
    const centerNameRef = useRef();
    const dateRef = useRef();
    const sessionNameRef = useRef();
    const [selectedCenterNameValue, setSelectedCenterNameValue] = useState(null)
    const [selectedDateValue, setSelectedDateValue] = useState(null)
    const [selectedSessionValue, setSelectedSessionValue] = useState(null)
    const [centerNameData, setSelectedCenterNameValues] = useState([])
    const [dateValues, setSelectedDateValues] = useState([])
    const [SessionData, setSelectedSessionValues] = useState([])

  
    useEffect(() => {
        
        dispatch(selectedMenu(8));
        dispatch(loadAllAttendance());
        if(attendanceAllData!==undefined)
        {
            if(attendanceAllData[0]!==undefined)
            {
                setSelectedCenterNameValues(attendanceAllData[0]['center_names']);
                setSelectedDateValues(attendanceAllData[0]['dates']);
                setSelectedSessionValues(attendanceAllData[0]['session_names']);
            }
        }
      
    }, [dispatch,attendanceAllData])
    
     const centerNameChangeHandler = () => {
        setSelectedCenterNameValue(centerNameRef.current.value)
    }

    const sessionNameChangeHandler = () => {
        setSelectedSessionValue(sessionNameRef.current.value)
    }

     const dateChangeHandler = () => {
        setSelectedDateValue(dateRef.current.value)
    }

    const generateReport = async () => {
        let obj = {
                center_name: selectedCenterNameValue,
                date: selectedDateValue,
                session_name: selectedSessionValue
            }
        dispatch(loadAttendanceReport(obj));
    }

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>Generate Attendance Report</Text>
                
            </Box>
            <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="space-between"
                mb="1rem"
                bgColor='white'
                pl='1rem'
                pb='1rem'
                pr='1rem'
                pt='1rem'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
            >
                <Box width="25%">
                    <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                    >
                        Center Name
                    </Text>
                    <Select
                        id='center_name'
                        width={["100%", "100%", "90%", "85%"]}
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        borderRadius="13px"
                        height='40px'
                        ref={centerNameRef}
                        value={selectedCenterNameValue}
                        onChange={centerNameChangeHandler}
                        fontSize='18px'
                    >
                        <option value='0' key='-1'>Select a Center Name</option>
                            {
                                centerNameData.map((centerName, idx) => <option value={centerName.center_name} key={idx}>{centerName.center_name}</option>)
                            }
                    </Select>
                </Box>
                <Box width="25%">
                    <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                    >
                        Date
                    </Text>
                    <Select
                        id='center_name'
                        width={["100%", "100%", "90%", "85%"]}
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        borderRadius="13px"
                        height='40px'
                        ref={dateRef}
                        value={selectedDateValue}
                        onChange={dateChangeHandler}
                        fontSize='18px'
                    >
                        <option value='0' key='-1'>Select Date</option>
                            {
                                dateValues.map((dates, idx) => <option value={dates.date} key={idx}>{dates.date}</option>)
                            }
                    </Select>
                </Box>
                <Box width="25%">
                    <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                    >
                        Session Name
                    </Text>
                    <Select
                        id='session_name'
                        width={["100%", "100%", "90%", "85%"]}
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        borderRadius="13px"
                        height='40px'
                        ref={sessionNameRef}
                        value={selectedSessionValue}
                        onChange={sessionNameChangeHandler}
                        fontSize='18px'
                    >

                        <option value='0' key='-1'>Select Session Name</option>
                            {SessionData!==undefined &&
                                SessionData.map((session, idx) => <option value={session.session_name} key={idx}>{session.session_name}</option>)
                            }
                    
                    </Select>
                </Box>
                       
                        <Box width="20%" pt='2rem'>
                            <Button
                                bgColor="#4a86e8"
                                color="#ffffff"
                                borderRadius="lg"
                                border="1px solid 4a86e8"
                                p={["6px 15px", "8px 20px", "12px 30px"]}
                                style={{ fontFamily: "Mulish, sans-serif" }}
                                fontWeight="800"
                                fontSize={["13px", "14px", "16px"]}
                                onClick={generateReport}
                              >
                            View Attendance
                          </Button>
                        </Box>
               
            </Box>
             <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="flex-start"
                mb="1rem"
                bgColor='white'
                pl='1rem'
                pb='1rem'
                pr='1rem'
                pt='1rem'
                borderRadius='10px'
                flexDirection='column'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
            >
             {
                attendanceReportsData.length > 0 ? (
                    <Table  variant='simple'  style={{borderRadius:'10px'}}>
                          <Thead border='1px solid rgba(0,0,0,0.1)'>
                            <Tr>
                              <Th rowSpan="2"  border='1px solid rgba(0,0,0,0.1)' fontWeight='800'>S.No</Th>
                              <Th rowSpan="2"  border='1px solid rgba(0,0,0,0.1)'  fontWeight='800'>Student Name</Th>
                              <Th rowSpan="2"  border='1px solid rgba(0,0,0,0.1)'   fontWeight='800'>Student Id</Th>
                              <Th colSpan="2"  border='1px solid rgba(0,0,0,0.1)'  fontWeight='800'>InComing Time</Th>
                            </Tr>
                            
                          </Thead>
                          <Tbody>
                          {
                                attendanceReportsData.map((attendance, idx) => (
                                        <Tr>
                                            <Td  border='1px solid rgba(0,0,0,0.1)'>{idx+1}</Td>
                                            <Td  border='1px solid rgba(0,0,0,0.1)'>{attendance.name}</Td>
                                            <Td  border='1px solid rgba(0,0,0,0.1)'>{attendance.student_id} </Td>
                                            <Td  border='1px solid rgba(0,0,0,0.1)'>{attendance.incoming_time} </Td>
                                        </Tr>
                                
                                        ))
                                
                                }
                          
                           </Tbody>
                            </Table>
                        ):(
                        <Box justifyContent="center" alignItem="center">
                        Report Not Found
                        </Box>
                        )}
           
       
            </Box>
           
       
        </Box>
    )
}
